"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.SiteLinks = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

/** Site Links to EarnUp Pages */
var styles = function styles(theme) {
  return (0, _defineProperty2["default"])({
    links: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      alignItems: 'left',
      height: 130
    },
    link: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.subtitle1.fontSize,
      lineHeight: theme.typography.subtitle1.lineHeight,
      fontWeight: '500'
    }
  }, theme.breakpoints.down('sm'), {
    links: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      alignItems: 'center',
      height: 160
    }
  });
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var SiteLinks = function SiteLinks(_ref2) {
  var items = _ref2.items,
      _ref2$Link = _ref2.Link,
      Link = _ref2$Link === void 0 ? _TrackingLink["default"] : _ref2$Link;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    className: classes.links,
    marginBottom: 2
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Link, {
      key: "footer-sitelinks-".concat(item.route),
      variant: item.variant,
      className: classes.link,
      to: item.route,
      dataQa: "footer-sitelinks-".concat(item.name)
    }, item.buttonName);
  }));
};

exports.SiteLinks = SiteLinks;
var _default = SiteLinks;
exports["default"] = _default;